var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{class:_vm.classFormGroupBind},[_c('b-form-checkbox',{attrs:{"disabled":_vm.disabled},on:{"input":($value) => _vm.$emit('input', $value)},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_c('span',{staticClass:"checkbox"},[_vm._v("\n      "+_vm._s(_vm.label || "Ativo")+"\n    ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }